
export type GetUsersParams = {
query?: string;
limit?: number;
};
